import React from 'react';

const SafetyReportModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-md w-full mx-4 transform transition-all">
        <div className="text-center">
          {/* Animated Document Icon */}
          <div className="mb-6 relative">
            <div className="mx-auto w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center animate-pulse">
              <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
              </svg>
            </div>
            {/* Animated rings */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 border-4 border-blue-200 rounded-full animate-ping"></div>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            Generating Safety Report
          </h3>
          
          {/* Status messages with animation */}
          <div className="space-y-3 my-6">
            <div className="flex items-center justify-center space-x-2 text-blue-600 animate-fadeIn">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
              <p className="text-sm font-medium">Analyzing safety metrics...</p>
            </div>
            
            <div className="flex items-center justify-center space-x-2 text-blue-600 animate-fadeIn animation-delay-500">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce animation-delay-200"></div>
              <p className="text-sm font-medium">Generating AI insights...</p>
            </div>
            
            <div className="flex items-center justify-center space-x-2 text-blue-600 animate-fadeIn animation-delay-1000">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce animation-delay-400"></div>
              <p className="text-sm font-medium">Compiling recommendations...</p>
            </div>

            <div className="flex items-center justify-center space-x-2 text-blue-600 animate-fadeIn animation-delay-1500">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce animation-delay-600"></div>
              <p className="text-sm font-medium">Formatting PDF report...</p>
            </div>
          </div>

          {/* Progress bar */}
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6 overflow-hidden">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full animate-progress"></div>
          </div>

          <p className="text-sm text-gray-500">
            <strong>Please wait...</strong> This comprehensive AI-powered analysis may take up to 30 seconds to generate.
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out forwards;
        }

        .animation-delay-500 {
          animation-delay: 0.5s;
          opacity: 0;
        }

        .animation-delay-1000 {
          animation-delay: 1s;
          opacity: 0;
        }

        .animation-delay-1500 {
          animation-delay: 1.5s;
          opacity: 0;
        }

        .animation-delay-200 {
          animation-delay: 0.2s;
        }

        .animation-delay-400 {
          animation-delay: 0.4s;
        }

        .animation-delay-600 {
          animation-delay: 0.6s;
        }

        .animate-progress {
          animation: progress 12s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default SafetyReportModal;
